import { axios } from '@/utils/request'

/**
 * 查询复诊挂号评价
 *
 * @author liwei
 * @date 2022-06-15 08:23:51
 */
export function viewRegisterCommentPage (parameter) {
  return axios({
    url: '/viewRegisterComment/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 复诊挂号评价列表
 *
 * @author liwei
 * @date 2022-06-15 08:23:51
 */
export function viewRegisterCommentList (parameter) {
  return axios({
    url: '/viewRegisterComment/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加复诊挂号评价
 *
 * @author liwei
 * @date 2022-06-15 08:23:51
 */
export function viewRegisterCommentAdd (parameter) {
  return axios({
    url: '/viewRegisterComment/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑复诊挂号评价
 *
 * @author liwei
 * @date 2022-06-15 08:23:51
 */
export function viewRegisterCommentEdit (parameter) {
  return axios({
    url: '/viewRegisterComment/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除复诊挂号评价
 *
 * @author liwei
 * @date 2022-06-15 08:23:51
 */
export function viewRegisterCommentDelete (parameter) {
  return axios({
    url: '/viewRegisterComment/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出复诊挂号评价
 *
 * @author liwei
 * @date 2022-06-15 08:23:51
 */
export function viewRegisterCommentExport (parameter) {
  return axios({
    url: '/viewRegisterComment/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
